import Vue from 'vue';
import { camelToTitle } from '../shared/helpers/TextTransform';

Vue.filter('camelToTitle', camelToTitle);
